export enum HistoryEntryAction {
  external_transfer = "EXTERNAL_TRANSFER",
  buy = "BUY",
  sell = "SELL",
  deposit = "DEPOSIT",
  withdraw = "WITHDRAW",
  unknown = "UNKNOWN",
}

export const HistoryEntryActionLabel = {
  [HistoryEntryAction.buy]: "Bought",
  [HistoryEntryAction.external_transfer]: "Transferred",
  [HistoryEntryAction.sell]: "Sold",
  [HistoryEntryAction.deposit]: "Deposited",
  [HistoryEntryAction.withdraw]: "Withdrawn",
  [HistoryEntryAction.unknown]: "Unknown action",
};
